import playerStore from '../../store/PlayerStore';
import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WBotWaitingHostRebuyEvent extends WEvent {
  pid: string;
  waitingRebuy: boolean;
  amount: number;

  constructor(event: WBotWaitingHostRebuyEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setPlayers(
        playerStore.modifyPlayers(table.players, this.pid, player => {
          player.waitingRebuy = this.waitingRebuy;
          player.waitingRebuyAmount = this.amount;
        }),
      );
      tableStore.changeFilterState();
    });
}
